<vdr-dropdown>
  <button class="trigger user-menu-btn" vdrDropdownTrigger>
    <div class="user-circle">
      <img 
        *ngIf="userAvatar" 
        [src]="userAvatar" 
        [alt]="userName"
        class="user-avatar"
      />
      <clr-icon *ngIf="!userAvatar" shape="user" size="16"></clr-icon>
    </div>
    <span class="user-name">{{ userName }}</span>
    <clr-icon class="md:hidden" shape="caret down"></clr-icon>
  </button>
  <vdr-dropdown-menu vdrPosition="bottom-right">
    <a [routerLink]="['/settings', 'profile']" vdrDropdownItem>
      <clr-icon shape="user" class="is-solid"></clr-icon>
      {{ 'settings.profile' | translate }}
    </a>
    <div class="dropdown-divider"></div>
    <button
      type="button"
      class="text-red-500"
      vdrDropdownItem
      (click)="logOut.emit()"
    >
      <clr-icon shape="logout"></clr-icon> {{ 'common.log-out' | translate }}
    </button>
  </vdr-dropdown-menu>
</vdr-dropdown>
